/**
 * App-wide alert messages _originally_ targeted for API/network calls (errors) _only_.
 * "Code" (for reference only) maps to "Business Exception Errors" in the spreadsheet managed by the BA.
 * RIMS' subsequent support of road test payment has forcibly mixed and matched non-API errors
 * into the global SystemAlert component, a.k.a. the orange banner. 😡
 *
 * Messages ~
 * status: 0 ~ involves network calls but API always return HTTP status 200 so frontend has to parse the response
 *    to determine the appropriate error message for display.
 * status: -1 ~ non-API (non-network call) errors that are displayed as if they are network errors.
 * status: -2 ~ unmapped error - but it should have been mapped and returned by API.
 */
export default [
  {
    code: 12,
    message: 'Please provide all the required information.',
    status: 400,
  },
  {
    code: 0,
    errorType: 'none',
    message: 'Your transaction is completed successfully. A confirmation text and/or e-mail has been sent to the information provided.',
    status: 200,
  },
  {
    code: 24,
    errorType: 'email',
    message: 'Your transaction is completed but we are experiencing technical difficulties in sending you an e-mail. ' +
      'Please re-try your e-mail confirmation request again.',
    status: 0,
  },
  {
    code: 25,
    errorType: 'sms',
    message: 'Your transaction is completed but we are experiencing technical difficulties in sending you a text message. ' +
      'Please re-try your text message confirmation request again.',
    status: 0,
  },
  {
    code: 26,
    errorType: 'both',
    message: 'Your transaction is completed but we are experiencing technical difficulties in sending you an e-mail ' +
      'and text message. Please re-try your e-mail and text message confirmation request again.',
    status: 0,
  },
  {
    code: 34,
    message: 'Your payment was not successful. Please try again.',
    status: 432,
  },
  {
    code: 35,
    message: 'Your payment was not successful. Please try again.',
    status: 432,
  },
  {
    code: 43,
    message: 'Sorry, we only support VISA, MasterCard, Discover and American Express.',
    status: -1,
  },
  {
    code: 44,
    message: 'The card number is invalid.', // for documentation only
    status: -1,
  },
  {
    code: 45,
    message: 'The expiration month and expiration year are invalid.',   // for documentation only
    status: -1,
  },
  {
    code: 500,
    message: 'We are experiencing technical difficulties. Please try your request again.',
    status: 500,
  }
];
